// src/utils/addLegend.js
import L from "leaflet";

export function addLegendToMap(map, htmlContent, id = "custom-legend") {
  const containerId = "vector-legend";
  let container = document.querySelector(`#${containerId}`);

  if (!container) {
    const legend = L.control({ position: "bottomright" });
    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "info legend");
      div.id = containerId;
      div.style.background = "white";
      div.style.padding = "10px";
      div.style.border = "1px solid black";
      div.style.borderRadius = "5px";
      div.style.boxShadow = "0 0 5px rgba(0,0,0,0.3)";
      div.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: center; font-weight: bold; color: black; min-width:200px; max-width:370px;">
          <span>Legend</span>
          <button style="background: red; color: white; border: none; padding: 2px 6px; border-radius: 3px; cursor: pointer;"
            onclick="this.parentElement.parentElement.style.display='none'">×</button>
        </div>
        <div id="legend-items" style="margin-top: 5px; max-height: 250px; overflow-y: auto; padding:5px 0px"></div>
      `;
      return div;
    };
    legend.addTo(map); 
  }

  // --- util to remove legend by id ---
  function removeLegendById(legendId) {
    const container = document.querySelector("#legend-items");
    if (!container) return;
    const item = container.querySelector(`[data-legend-id="${legendId}"]`);
    if (item) {
      item.remove();
      console.log(" Legend removed for:", legendId);
    }
  }

  // listen to overlayremove event
  map.on("overlayremove", (e) => {
    if (e && e.id) {
      removeLegendById(e.id);
    }
  });
  

  // listen to global layersCleared (for mass removal)
  window.addEventListener("layersCleared", () => {
    const container = document.querySelector("#legend-items");
    if (container) container.innerHTML = "";
    console.log(" All legends cleared");
  });


  setTimeout(() => {
  const container = document.querySelector("#legend-items");
  if (container) {
    const match = htmlContent.match(/id="([^"]+)"/);
    // const legendId = match ? match[1] : null;
    const legendId = id;
    if (!legendId) {
      console.warn(" No legendId found in htmlContent. Please ensure <div id='legend-xxx'> is set.");
      return;
    }

    // check if it already exists
    let existing = container.querySelector(`[data-legend-id="${legendId}"]`);

    if (existing) {
      //  update instead of remove & add
      const contentDiv = existing.querySelector(".legend-content");
      if (contentDiv) {
        contentDiv.innerHTML = htmlContent;  // just update
      }
      return;
    }

    // create a new legend item if not found
    const item = document.createElement("div");
    item.setAttribute("data-legend-id",legendId);
    item.innerHTML = `
      <div style="position: relative; padding-right: 2px;">
        <div class="legend-content">${htmlContent}</div>
        <button class="legend-remove-btn"
          style="
            position: absolute;
            top: 2px;
            right: 4px;
            background: #d9534f;
            color: white;
            border: none;
            padding: 2px 6px;
            border-radius: 3px;
            cursor: pointer;
          "
          title="Remove legend item"
        >×</button>
      </div>
    `;

    const removeButton = item.querySelector(".legend-remove-btn");
    removeButton.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.confirm("Remove this legend?")) {
        const itemToRemove = e.target.closest("[data-legend-id]");
        if (itemToRemove) itemToRemove.remove();
      }
    });

    container.appendChild(item);
  }
}, 200);

// Return the final rendered legend container (so MapCreation can use it)
const legend_container = document.querySelector("#vector-legend");
return legend_container ? legend_container.outerHTML : "";


}
